import Backbone from 'backbone'

export default Backbone.View.extend({

  setBounds: function (area) {
    area.right = area.left + area.width
    area.bottom = area.top + area.height
    return area
  }

})
